import { Theme } from '@mui/material/styles';

export function iconButton(theme: Theme) {
  return {
    MuiIconButton: {
      defaultProps: {
        size: 'large',
      },
    },
  };
}
